/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SiteSelectItemDto } from '../../models/site-select-item-dto';

export interface GetSiteSelectItemsOfMerchant$Params {
}

export function getSiteSelectItemsOfMerchant(http: HttpClient, rootUrl: string, params?: GetSiteSelectItemsOfMerchant$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SiteSelectItemDto>>> {
  const rb = new RequestBuilder(rootUrl, getSiteSelectItemsOfMerchant.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SiteSelectItemDto>>;
    })
  );
}

getSiteSelectItemsOfMerchant.PATH = '/merchants/current/sites/select-items';
